<template>
  <div>
    <el-row style="height: 40px">
      <el-col :span="24">
        <el-button type="primary" size="small" @click="showImport=true" style="margin-right: 15px">导入订单</el-button>
        <el-select v-model="sendValue" size="small" style="width: 120px" placeholder="请选择">
          <el-option
            v-for="item in sendOpto"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" size="small" @click="send">批量发货</el-button>
        <el-button v-show="false" type="primary" size="small" @click="reSend">已发货，发错重发</el-button>
        <el-button type="primary" size="small" @click="getCompany">获取物流公司</el-button>

        <el-button type="primary" size="small" @click="showCompany=true" style="margin-right: 15px">查看物流公司名称</el-button>

        <el-link href="./static/template/fahuo.xls"  type="primary" style="margin-left: 20px">批量发货模板</el-link>
      </el-col>
    </el-row>
    <el-row style="height: 40px; display: none">
      <el-col><span style="color: red">提示：不能发其他店铺订单，不能发已发过货的订单，检测到就会停止发货，排除错单后重新导入发货。切记！切记！切记！写这么长你该看到了吧！要不再给你闪两下~</span></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table border style="font-size: 12px" :data="logisData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">
          <el-table-column  label="ID"
                            type="index"
                            :index="indexMethod">
          </el-table-column>
          <el-table-column  prop="tid" label="订单号" width="200px"></el-table-column>
          <el-table-column  prop="oid" label="子订单号" width="200px"></el-table-column>
          <el-table-column  prop="logisNo" label="运单号" width="140px"></el-table-column>
          <el-table-column  prop="logisName" label="物流公司" width="100px"></el-table-column>

          <el-table-column  prop="status" label="状态" ></el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-dialog
      title="导入订单"
      :visible.sync="showImport"
      width="50%"
      center>
      <span style="margin-left:20px; margin-bottom: 30px">复制Excel表格里的订单，在这里粘贴（格式：订单号，子订单号，运单号，物流公司）</span>
      <el-input :rows="10" type="textarea" v-model="logisTxt" > </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false">取 消</el-button>
        <el-button type="primary" @click="uploadData">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="物流公司名称"
      :visible.sync="showCompany"
      width="600px"
      center>
      <el-tag style="margin-right: 20px; margin-top: 20px;"
        :key="tag"
        v-for="tag in company"
              effect="plain"
        :disable-transitions="false"
        >
        {{tag}}
      </el-tag>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showCompany = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import {hideLoading, showLoading} from "../api/loading";

    export default {
        name: "Logistics",
      data(){
          return{
            deny:0,
            showImport:false,
            showCompany:false,
            status:'WAIT_SELLER_SEND_GOODS',
            logisTxt:'',
            logisData:[],
            sendValue:'offline',
            sendOpto:[{label:'自己联系',value:'offline'}],
            company:[ '顺丰','申通','韵达', '中通', '百世快递', '圆通',  '德邦快递',
              'EMS','EMS经济快递','邮政国内小包'],
          }
      },
      methods:{
        indexMethod(index)
        {
          return index + 1;
        },
        getLogisData:function () {
          let param={
            nick:storage.get("nick"),
          }
          $api.post("/logis/get", param, response =>{
            let dataResult = response.data;
            console.log(dataResult)
            if (dataResult.state == 1 && dataResult.message == "ok"){
                 this.logisData = dataResult.data;
              }
              else{
                this.$message.error(dataResult);
                this.$router.replace({name: "Index"});
                this.deny = 1;
              }
            })
          hideLoading();
        },
        uploadData:function () {
          this.showImport = false;
          if(this.deny == 1){
            this.$message.error("您没有该权限, 请联系主号分配权限。");
            return;
          }
          let param={
            nick:storage.get("nick"),
            txt: this.logisTxt
          }
          $api.post("/logis/import", param, response =>{
            console.log(response)
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok"){
              this.logisTxt = '';
              this.getLogisData();
              console.log("end.")
            }
            else{
              this.$message.error(dataResult.data.message);
            }
          })

        },
        send:function(){
          this.status = 'WAIT_SELLER_SEND_GOODS';
          this.sendGoods();
        },
        reSend:function(){
          this.status = 'WAIT_BUYER_CONFIRM_GOODS';
          this.sendGoods();
        },

        sendGoods:function () {
          if(this.deny == 1){
            this.$message.error("您没有该权限, 请联系主号分配权限。");
            return;
          }
          let param={
            nick:storage.get("nick"),
            status: this.status,
            sendValue: this.sendValue
          }
          $api.post("/logis/sendgoods", param, response =>{
            console.log(response)
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok"){

              this.getLogisData();
              this.$message.success("批量发货完成。")
            }
            else{
              this.$message.error(dataResult.data.message);
            }
          })
        },

        getCompany:function(){
          let param={
            nick: storage.get('nick')
          }
          $api.post("/logis/getCompany", param, response =>{
            console.log(response)
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok"){
              this.$message.success("获取物流公司完成。")
            }
            else{
              this.$message.error(dataResult.data.message);
            }
          })
        }
      },
      mounted(){
        this.getLogisData();
      }
    }
</script>

<style >


</style>



// WEBPACK FOOTER //
// src/page/Logistics.vue